const pkg: Record<string, any> = {
    name: "clueManageList",
    path: "/app-clueManageList",
    component: "basic",
    meta: {
        title: "clueManageList",
        i18nTitle: "Routes.clueManageList.list",
        requiresAuth: true,
        keepAlive: true,
        icon: "fluent:book-information-24-regular",
        order: 2,
        permissions: ["system:lead:list"],
    },
    children: [
        {
            name: "clueManageList_list",
            path: "/clueManageList/list",
            component: "self",
            meta: {
                title: "clueManageList",
                i18nTitle: "Routes.clueManageList.list",
                requiresAuth: true,
                keepAlive: true,
                icon: "ic:round-tab",
            },
        },
    ],
}

export default pkg
